module.exports = __webpack_public_path__ + "static/media/likebn.bac49901.png";